<div class="ne-confirm" data-test-page="confirm">
  <div class="ne-title">
    <Title>
      Preview Your Personalized Note
    </Title>
  </div>

  <div class="ne-section">
    <div class="ne-left-side">
      <div>
        <NotePreview isPreview=true layout={$store.layout.state}/>
      </div>
    </div>

    <div class="ne-right-side">
      <Checkbox
        id="agree"
        value="agree"
        heapId="agree-to-terms"
        testId="agree-to-terms"
        checked="{$store.didAgreeToTerms.state}"
        choose="{event => store.set($store.didAgreeToTerms.set(event.target.checked))}">
        I have checked my personalized note and/or photograph for errors and agree to Lovepop’s <a href={$store.terms.state} target="_blank" rel="noopener noreferrer">Terms of Services</a> to proceed.
      </Checkbox>
    </div>
  </div>

  <Nav
    forward="{forward}"
    back="{back}"
    backText="{backText}"
    forwardText="Schedule Delivery"
    isSaving={$store.isSaving.state}
    forwardDisabled={!$store.didAgreeToTerms.state}
    />
</div>

<style>
  .ne-confirm{
    box-sizing: border-box;
  }

  .ne-confirm :global(*),
  .ne-confirm :global(*):before,
  .ne-confirm :global(*):after {
    box-sizing: inherit;
  }

  .ne-title {
    justify-self: space-evenly;
  }

  .ne-confirm {
    position: relative;
    width: 100%;
    min-width: 380px;
    height: 100%;
  }

  .ne-section {
    display: flex;
    justify-content: center;
  }

  .ne-left-side {
    width: 50%;
    padding: 0 1em;
    display: flex;
    justify-content: flex-end;
  }

  .ne-right-side {
    width: 50%;
    display: flex;
    padding: 0 1em;
    flex-direction: column;
    justify-content: flex-end;
  }

  @media (max-width: 768px) {
    .ne-section {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .ne-left-side,
    .ne-right-side {
      justify-content: center;
      width: 100%;
    }
  }
</style>

<script>
  import Title from '../components/Title.html';
  import Nav from '../components/Nav.html';
  import PreviewContainer from '../components/PreviewContainer.html';
  import NotePreview from '../components/NotePreview.html';
  import Checkbox from '../components/Checkbox.html';
  import { store, history, theme } from '../stores';

  export let back;
  export let forward;
  export let forwardText;
  export let backText
</script>
